import "./Rating.scss";
import { range } from "lodash";
import { clsx } from "clsx";
import { Rating as RatingIcon } from "@/icons/Rating";

export type RatingProps = {
  onClick: (value: number) => void;
  rating?: number;
};

const STAR_QUANTITY = 5;
const STARS = range(1, STAR_QUANTITY + 1);

export function Rating({ onClick, rating = 0 }: RatingProps) {
  const isRatingActive = (num: number) => num <= rating;

  return (
    <fieldset className="rating">
      <legend className="visually-hidden">Valutazione</legend>
      {STARS.map((num, index) => (
        <button
          key={index}
          onClick={() => onClick(num)}
          className={clsx("star black-focus", {
            active: isRatingActive(num),
          })}
        >
          <RatingIcon className="icon icon-sm" />

          <span className="visually-hidden">
            Valuta {num} stelle su {STAR_QUANTITY}
          </span>
        </button>
      ))}
    </fieldset>
  );
}
